import React, { useState, useEffect } from "react";
import ContentLoader from 'react-content-loader';
import MaterialTable from "material-table";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { Link, useLocation } from "react-router-dom";
import { getTrans as t } from "../../Localization/translations";
import AddcategoryService from "../../services/category/categoryAddServices";

const Categoryview = () => {
    const [line_items, SetLine_Items] = useState([]);
    const { state } = useLocation();
    const [loading, setLoading] = useState(true);
    const [category_name, setCategory_name] = useState("")

    useEffect(() => {
        AddcategoryService.getCategory(state).then((response) => {
            setCategory_name(response.data.category_name);
            SetLine_Items(response.data.sub_categories);
            setLoading(false);

        });
    }, [state]);

    return (
        <div className="container-fluid">
            {loading === false ? (
                <>
                    <div className="row">
                        <div className="header pt-3">
                            <h5 className="title mb-0 ">{t("Category")}</h5>
                            <h6>
                                <Link to="/categories" className="tc">
                                    {t("Category")}
                                </Link>{" "}
                                / <span>{t("View Category")}</span>
                            </h6>
                        </div>
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="success"></div>
                                    <div className="row">
                                        <div className="row">
                                            <div className="form-group row">
                                                <div className="col-xl-3">
                                                    <label className="col-lg-8 col-form-label">
                                                        {t("Category Name")}{" "}
                                                        <Tooltip content={t("Category_Tooltip")}>
                                                            <i className="fa fa-light fa-circle-info"></i>
                                                        </Tooltip>
                                                    </label>
                                                </div>
                                                <div className="col-xl-4">
                                                    <span className="col-lg-8 view-label p">
                                                        {category_name ? category_name : "None"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" id="payschedule" style={{ marginTop: "5px" }}>
                        <div className="col-md-12">
                            <div className="">
                                <div className="body">
                                    <div className="table-responsive">
                                        <MaterialTable
                                            style={{
                                                padding: "0.5rem 0.5rem",
                                                backgroundColor: "var(--bs-table-bg)",
                                                borderBottomWidth: "1px",
                                                boxShadow:
                                                    "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                            }}
                                            columns={[
                                                {
                                                    title: `${t("Sub Category Name")}`,
                                                    field: "sub_category_name",
                                                    render: rowData => <>
                                                        <div className="d-xl-none tc d-md-none d-lg-none">
                                                            {t("Sub Category Name")}{" "}
                                                        </div>
                                                        <div className="">{(rowData.sub_category_name)}</div></>, headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left",
                                                        },
                                                    cellStyle: {
                                                        textAlign: "left",
                                                        fontSize: 12,
                                                    },
                                                },
                                            ]}
                                            data={line_items}
                                            options={{
                                                headerStyle: {
                                                    backgroundColor: "white",
                                                    color: "#245C7F",
                                                    fontSize: 12,
                                                },
                                                rowStyle: (rowData, index) => {
                                                    if (index % 2) {
                                                        return { backgroundColor: "#fff" };
                                                    }
                                                },
                                                sorting: true,
                                                search: false,
                                                toolbar: false,
                                                paging: true,
                                                pageSize: 15,
                                                emptyRowsWhenPaging: false,
                                                pageSizeOptions: [10, 20, 25, 50],
                                                paginationType: "stepped",
                                                showFirstLastPageButtons: false,
                                                actionsColumnIndex: -1,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <ContentLoader
                    viewBox="0 0 400 160"
                    backgroundColor="rgba(0,0,0,0.06)"
                    foregroundColor="rgba(0,0,0,0.12)"
                >
                    <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
                    <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
                    <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
                    <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
                    <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
                    <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
                </ContentLoader>
            )}
        </div>
    )
}

export default Categoryview